import React from "react";
import Locale from "../../../locale/Locale";

export default class Pager extends React.Component {

    renderPageLink(page, title) {
        return (
            <div
                key={ page}
                style={{ 
                    display: 'inline-block',
                    marginRight: 5, 
                    fontWeight: this.props.currentPage === page ? "bold" : "normal",
                    cursor: 'pointer'
                }} 
                onClick={ () => {
                    this.props.onChange(page);
                }
            }>{ title || page }</div>
        );
    }
    renderPageLinks(pages) {
        return pages.map(page => {
            return this.renderPageLink(page);
        })
    }

    render() {
        let pageCount = this.props.pageCount || Math.ceil(this.props.totalCount / (this.props.pageSize || 100));
        if (pageCount === 1 || isNaN(pageCount)) {
            console.log("Pager error", this.props);
            return null;
        }
        let directPageCount = this.props.directPageCount || 3;
        let pages = [];
        if (pageCount < directPageCount * 2) {
            let pageList = [];
            for (let i = 1; i <= pageCount; i++)
                pageList.push(i);
            pages = [ ...this.renderPageLinks(pageList) ];
        } else {
            let frontPages = [ ...Array(Math.min(pageCount, directPageCount)).keys() ].map(i => i+1);
            let midPages = [ this.props.currentPage ];
            let endPages = [ ...Array(directPageCount).keys() ].map(i => pageCount - (directPageCount - i) + 1);
            pages = [
                ...this.renderPageLinks(frontPages), "...", 
                ...(this.props.currentPage > directPageCount && this.props.currentPage < pageCount - directPageCount + 1 ? [...this.renderPageLinks(midPages), "..." ] : []), 
                ...this.renderPageLinks(endPages)
            ];
        }

        return (
            <div className="Pager" style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <div style={{ overflowY: 'auto', flex: 1 }}>
                    { Locale.gettext("Page %1$s of %2$s. %3$s items total", this.props.currentPage, pageCount, this.props.totalCount) }
                </div>
                <div >
                    { this.props.currentPage > 2 ? this.renderPageLink(1, "<<") : null }
                    { this.props.currentPage > 1 ? this.renderPageLink(this.props.currentPage - 1, "<") : null }
                    { pages }
                    { this.props.currentPage < pageCount ? this.renderPageLink(this.props.currentPage + 1, ">") : null }
                    { this.props.currentPage < pageCount -1 ? this.renderPageLink(pageCount, ">>") : null }
                </div>
            </div>
        );
    }
}